import ProducersService from './resources/producers.service';
import FieldsService from './resources/fields.service';
import PlotsService from './resources/plots.service';
import PlotPermissionsService from './resources/plot-permissions.service';
import PlotsRainsService from './resources/plot-rains.service';
import ProductionDestinationsService from './resources/production-destinations.service';

import PreEmergenceService from './resources/pre-emergence.service';
import EmergenceService from './resources/emergence.service';
import HarvestService from './resources/harvest.service';
import PicturesService from './resources/pictures.service';
import PlotStageCommentsService from './resources/plot-stage-comments.service';

import DistributorsService from './resources/distributors.service';
import SellersService from './resources/sellers.service';

import VisitsService from './resources/visits.service';
import CommentsService from './resources/comments.service';

import VarietiesService from './resources/varieties.service';
import PlotTypesService from './resources/plot-types.service';
import CropsService from './resources/crops.service';
import CampaignsService from './resources/campaigns.service';
import CampaignDatesService from './resources/campaign-dates.service';
import ArticlesService from './resources/articles.service';

import CitiesService from './resources/cities.service';
import ProvincesService from './resources/provinces.service';

import PermissionsService from './resources/permissions.service';
import RolesService from './resources/roles.service';
import UsersService from './resources/users.service';

import ProjectionsService from './resources/projections.service';
import ProjectionActivitiesService from './resources/projection-activities.service';
import ProjectionStatesService from './resources/projection-states.service';
import ProjectionStatisticsService from './resources/projections-statistics.service';
import ProjectionGenerateService from './resources/projection-generate.service';
import ProjectionsChartsService from './resources/projections-charts.service';

import ContactsService from './resources/contacts.service';

import DocumentsService from './resources/documents.service';
import DocumentCommentsService from './resources/document-comments.service';

import OrdersService from './resources/orders.service';
import OrderStatesService from './resources/order-states.service';
import OrderItemsService from './resources/order-items.service';
import OrdersStatisticsService from './resources/orders-statistics.service';

import QuotationsService from './resources/quotations.service';
import QuotationStatesService from './resources/quotation-states.service';
import QuotationItemsService from './resources/quotation-items.service';
import QuotationPicturesService from './resources/quotation-pictures.service';

import MapsService from './resources/maps.service';

import DollarQuotationsService from './resources/dollar-quotations.service';
import ConfigurationsService from './resources/configurations.service';

import DeliveryNotesService from './resources/delivery-notes.service';
import DeliveryNoteItemsService from './resources/delivery-note-items.service';
import DeliveryNoteTypesService from './resources/delivery-note-types.service';
import StocksService from './resources/stocks.service';

import ReceiptsService from './resources/receipts.service';
import ConceptPaymentTypeService from './resources/concept-payment-types.service';

import LiquidationService from './resources/liquidation.service';

import DocumentReceiptTypesService from './resources/document-receipt-types.service';

import ConceptPaymentService from './resources/concept-payments.service';

const services = {
  articles: new ArticlesService(),
  campaigns: new CampaignsService(),
  campaign_dates: new CampaignDatesService(),
  cities: new CitiesService(),
  comments: new CommentsService(),
  concept_payment_types: new ConceptPaymentTypeService(),
  contacts: new ContactsService(),
  crops: new CropsService(),
  distributors: new DistributorsService(),
  fields: new FieldsService(),
  permissions: new PermissionsService(),
  plots: new PlotsService(),
  plot_permissions: new PlotPermissionsService(),
  pictures: new PicturesService(),
  pre_emergences: new PreEmergenceService(),
  emergences: new EmergenceService(),
  harvests: new HarvestService(),
  maps: new MapsService(),
  orders: new OrdersService(),
  orders_statistics: new OrdersStatisticsService(),
  order_states: new OrderStatesService(),
  order_items: new OrderItemsService(),
  producers: new ProducersService(),
  provinces: new ProvincesService(),
  receipts: new ReceiptsService(),
  roles: new RolesService(),
  sellers: new SellersService(),
  users: new UsersService(),
  plot_types: new PlotTypesService(),
  varieties: new VarietiesService(),
  visits: new VisitsService(),
  documents: new DocumentsService(),
  document_comments: new DocumentCommentsService(),
  projections: new ProjectionsService(),
  projection_activities: new ProjectionActivitiesService(),
  projection_states: new ProjectionStatesService(),
  projection_statistics: new ProjectionStatisticsService(),
  projection_generate: new ProjectionGenerateService(),
  projection_charts: new ProjectionsChartsService(),
  quotations: new QuotationsService(),
  quotation_states: new QuotationStatesService(),
  quotation_items: new QuotationItemsService(),
  quotation_pictures: new QuotationPicturesService(),
  plot_rains: new PlotsRainsService(),
  production_destinations: new ProductionDestinationsService(),
  plot_stage_comments: new PlotStageCommentsService(),
  dollar_quotations: new DollarQuotationsService(),
  configurations: new ConfigurationsService(),
  delivery_notes: new DeliveryNotesService(),
  delivery_note_items: new DeliveryNoteItemsService(),
  delivery_note_types: new DeliveryNoteTypesService(),
  stocks: new StocksService(),
  liquidations: new LiquidationService(),
  document_receipt_types: new DocumentReceiptTypesService(),
  concept_payments: new ConceptPaymentService(),
};

export default {
  resource: (name) => services[name],
};
